import { render, staticRenderFns } from "./DigitalBook.vue?vue&type=template&id=5de5a3e2&scoped=true&"
import script from "./DigitalBook.vue?vue&type=script&lang=js&"
export * from "./DigitalBook.vue?vue&type=script&lang=js&"
import style0 from "./DigitalBook.vue?vue&type=style&index=0&id=5de5a3e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de5a3e2",
  null
  
)

export default component.exports